export default __webpack_public_path__ + "static/media/serviceAwards.c01c01e9.svg";